import { useMemo } from "react";
import { useGetPublicPricingSettingsQuery } from "@/store";
import { DEFAULT_PRICING } from "@/constants/pricing";

export interface PricingSettings {
  deliveryFee: number;
  taxRate: number;
}

/**
 * Hook to get pricing settings from the API (public endpoint, no auth required)
 * Returns default values if settings are not loaded yet
 */
export function usePricingSettings(): {
  deliveryFee: number;
  taxRate: number;
  isLoading: boolean;
} {
  const { data, isLoading } = useGetPublicPricingSettingsQuery();

  const settings = useMemo(() => {
    if (!data?.data) {
      return {
        deliveryFee: DEFAULT_PRICING.DELIVERY_FEE,
        taxRate: DEFAULT_PRICING.TAX_RATE,
      };
    }

    return {
      deliveryFee: data.data.deliveryFee || 0,
      taxRate: data.data.taxRate || 0,
    };
  }, [data]);

  return {
    ...settings,
    isLoading,
  };
}
